import { render } from "./table2.vue?vue&type=template&id=3d8d06e4&scoped=true"
import script from "./table2.vue?vue&type=script&lang=js"
export * from "./table2.vue?vue&type=script&lang=js"

import "./table2.vue?vue&type=style&index=0&id=3d8d06e4&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8d06e4"]])

export default __exports__